<template>
  <v-card class="main-content-card" flat>
    <v-toolbar flat>
      <v-toolbar-title>科研经费到款统计</v-toolbar-title>
    </v-toolbar>
    <v-tabs
      centered
      color="cyan"
      dark
      icons-and-text
    >

      <v-tabs-slider color="yellow"></v-tabs-slider>

      <v-tab href="#tab-1">学校<v-icon>business</v-icon></v-tab>
      <v-tab href="#tab-2">学院<v-icon>group</v-icon></v-tab>
      <v-tab href="#tab-3">教师<v-icon>person</v-icon></v-tab>

      <v-tab-item
        :value="'tab-'+1"
        :key="1"
      >
      <fund-search/>
      </v-tab-item>
      <v-tab-item
        :value="'tab-'+2"
        :key="2"
      >
        <academy-fund-search/>
      </v-tab-item>
      <v-tab-item
        :value="'tab-'+3"
        :key="3"
      >
        <teacher-fund-search/>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>
<script>
  import FundSearch from './FundSearch'
  import AcademyFundSearch from './AcademyFundSearch'
  import TeacherFundSearch from './TeacherFundSearch'
  export default {
    name: "Fund",
    components: {
      FundSearch,
      AcademyFundSearch,
      TeacherFundSearch
    },
    data () {
      return {
        searchName: '',
        loading: false,
        /**
         * 验证规则
         */
        rules: {

        },

      }
    },
    created() {

    },
    watch: {

    },

    computed: {

    },

    methods: {
      // 检索响应函数
      onSearchName() {
        this.filters.name = this.searchName
      }
    }
  }
</script>
